module.exports = __webpack_public_path__ + "static/media/D_J.52648146.png";